"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var questions = {
    "EF Skill": {
        Inhibition: [
            "I have a hard time waiting to be called on.",
            "I start my work before instructions can be given.",
            "I switch from tab to tab on my computer and/or want to check my phone.",
            "I find it difficult to pay attention in class, especially when it isn't my favorite subject.",
            "I am easily distracted and find it hard to get back on task.",
        ],
        Initiation: [
            "It is hard to get started on my homework.",
            "I might know what to do, but procrastinate.",
            "I don't know where to start on a big project.",
            "I find it difficut to stick to a schedule for studying.",
            "I don't know how to prioritize my homework because I have so much to do.",
        ],
        Shifting: [
            "It is hard to stop something I like to do and switch to something else.",
            "I really don’t like if plans change.",
            "I want to know the BEST or the RIGHT way to do something.  I don’t like if there are multiple ways to do something.",
            "I often get stuck on one problem and stay there instead of moving on.",
            "I get stuck on parts of a project and can’t move forward. ",
        ],
        "Emotional Control": [
            "I get upset if my teachers or parents tell me I must redo my work or if they tell me I am wrong.",
            "When I am stuck or frustrated, I have a hard time doing anything.",
            "I can get stuck trying to make things RIGHT or PERFECT. I sometimes can’t get started or move on because of this.",
            "I have a lot of anxiety at school.",
            "Sometimes I am upset and  don't pay attention to classroom instructions.",
        ],
        "Planning and Organization": [
            "I have a hard time making charts, diagrams, and/or my notes clear and organized.",
            "I sometimes know what I want to say or write, but it doesn’t come out right or at all.",
            "I have trouble knowing due dates and work on a project or essay last minute and all at once.",
            "The only time I study is when I know there is a test.",
            "I have trouble figuring out about how long an assignment or project will take me and don't always allow enough time.",
        ],
        "Materials Organization": [
            "I lose things at school and at home.",
            "I do my homework but lose it or forget to turn it in.",
            "I can’t find things that I saved on the computer or remember where I found a good resource/website/etc.",
            "My desk is messy and it’s hard for me to find things.",
            "It is hard for me to keep my binder in order.",
        ],
        "Working Memory": [
            "When my teacher or parents are giving directions, I can only remember part of them.  I can forget what I was doing halfway through.",
            "I can miss points for skipping steps or miss a word when writing.",
            "I need to reread things I have read.",
            "I need a lot of repetition to remember how to do things.",
            "I have trouble remembering multiple directions.",
        ],
        "Self-Monitoring": [
            "I can make the same mistakes multiple times.",
            "When I finish my work, I am so happy it is done that I put it away and don’t want to look at it again.",
            "I am surprised when my teacher or my parents tell me I was doing something wrong or I wasn’t paying attention.",
            "I make excuses when I don’t do a homework assignment.",
            "I don't know why my teacher marked something wrong. ",
        ],
    },
    "Study Skill": {
        "Time Management": [
            "I underestimate or overestimate how long things will take. ",
            "I feel like I never have enough time to get my homework done. ",
            "I'm not sure what time I have available to do my homework. ",
            "I leave assignments until the last minute. ",
            "I have trouble completing assignments on time. ",
        ],
        "Note-Taking": [
            "I will skip assigned readings if I don't have anything to turn in for that reading.",
            "When I re-read my notes it is hard to remember what I wrote or why I wrote it down.",
            'I can "zone out" when reading or in class and miss details.',
            "It is difficult keeping up with the information in class.",
            "I have a hard time knowing the important details from a reading or from what a teacher says.",
        ],
        "Active Studying": [
            "When studying, I can't think of questions that might be on a test.",
            "I don't know what to study. ",
            "When taking a test, I realize I have studied the wrong material. ",
            "It's hard for me to think of other ways to study besides quizlet or looking over my notes. ",
            "I memorize formulas, rules, technical definitions etc. without really understanding them or when/how to use them. ",
        ],
        "Self-Advocacy": [
            "I don't like to email or meet with my teachers one on one. ",
            "I don't know what to do when I don’t have the needed materials to complete an assignment. ",
            "If directions are confusing or unclear, I like to figure it out on my own. ",
            "I feel frustrated or embarrased when I need to ask for help. ",
            "When I am struggling with an assignment, it is hard for me to know what I need. ",
        ],
        "Test-Taking Strategies": [
            "On an exam, I forget to underline or circle key words in a short answer or essay question. ",
            "I will begin writing an essay or short answer immediately after reading the test question. ",
            "I second guess myself and change my answers on tests. ",
            "I can get stuck on a problem and having trouble finishing in time. ",
            "I lose points on a test because I didn’t understand the directions. ",
        ],
        "Growth Mindset": [
            "I don't like receiving feedback on my performance from my parents, coaches or teachers. ",
            "I feel like smart people do not need to try hard. ",
            "I believe you can't change how intelligent you are. ",
            "I have a hard time believing my effort will make a difference. ",
            "If I can’t do it right the first time I don't like trying again.  ",
        ],
    },
};
var format = function (categories) {
    return lodash_1.flatMap(categories, function (groups, category) {
        return lodash_1.flatMap(groups, function (questions, group) {
            return lodash_1.flatMap(questions, function (question) { return ({
                text: question,
                category: category,
                group: group,
            }); });
        });
    });
};
var formatted = format(questions);
exports.QUESTIONS_BY_CATEGORY_AND_GROUP = questions;
exports.default = formatted;
//# sourceMappingURL=questions.js.map